<template>
    <div id="dashboard-right-sidebar">
        <component :is="currentSidebar" class="content" />
    </div>
</template>

<script>
import BillingSidebar from "@/views/account/billing/Sidebar.vue";
import ChangePlanSidebar from "@/views/account/billing/ChangePlan/Sidebar.vue";

export default {
    components: {
        BillingSidebar,
        ChangePlanSidebar,
    },
    data() {
        return {
            drawer: this.$vuetify.breakpoint.mdAndUp,
        };
    },

    // watch: {
    //    '$route.name'(val) {
    //        this.drawer = !['account.invitations','account.billing','account.profile'].includes(val)
    //    }
    // },

    computed: {
        currentSidebar() {
            if (this.$route.name == "account.billing") {
                return BillingSidebar;
            }
            if (this.$route.name == "account.billing.changePlan") {
                return ChangePlanSidebar;
            }
            else {
                return false;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
#dashboard-right-sidebar {
    background-color: #121212;
    color: #989898;
    padding: 20px;
    display: grid;
    justify-content: stretch;
    align-items: center;
}
</style>
